import { render } from "./Index.vue?vue&type=template&id=f38a5d8e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=f38a5d8e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f38a5d8e"

export default script